import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const DistrictList = Loadable(lazy(() => import('pages/district/List')));
const DistrictCreate = Loadable(lazy(() => import('pages/district/Create')));
const DistrictView = Loadable(lazy(() => import('pages/district/View')));
const DistrictEdit = Loadable(lazy(() => import('pages/district/Edit')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const DistrictRoutes: RouteObject = {
    path: 'district',
    children: [
        {
            path: '',
            element: <DistrictList />,
        },
        {
            path: 'new',
            element: <DistrictCreate />,
        },
        {
            path: ':id',
            element: <DistrictView />,
        },
        {
            path: ':id/edit',
            element: <DistrictEdit />,
        },
    ],
};
export default DistrictRoutes;
